import * as React from "react";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableBody from "@mui/material/TableBody";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";

// Transition for the slide animation
const Transition = React.forwardRef(function Transition(
  props, // No type annotations here
  ref
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ReceiveDetailDialog = ({
  data,
  dataHeader,
  openReceiveDetail,
  handleCloseReceiveDetail,
}) => {
  // console.log("Ini data detail", data);
  // console.log("Ini data header", dataHeader);
  return (
    <Dialog
      fullScreen
      open={openReceiveDetail}
      onClose={handleCloseReceiveDetail}
      TransitionComponent={Transition}
    >
      <AppBar sx={{ position: "relative" }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleCloseReceiveDetail}
            aria-label="close"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography
            sx={{ ml: 2, flex: 1, textAlign: "center" }}
            variant="h6"
            component="div"
          >
            Receive Detail
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ p: 2, borderRadius: 3, bgcolor: "#f5f5f5", mb: 2 }}>
        <Box
          sx={{
            p: 2,
            borderRadius: 2,
            bgcolor: "#ffffff",
            boxShadow: 1,
            mb: 1,
            cursor: "pointer",
            display: "flex",
            flexDirection: { xs: "column", sm: "row" }, // Responsive
            gap: 4,
            flexWrap: "wrap",
          }}
        >
          {/* Transfer Code */}
          <Box sx={{ minWidth: 200 }}>
            <Typography variant="body2" color="text.secondary">
              Transfer Code
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {dataHeader?.transfer_code || "-"}
            </Typography>
          </Box>

          {/* Transfer Date */}
          <Box sx={{ minWidth: 200 }}>
            <Typography variant="body2" color="text.secondary">
              Transfer Date
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {dataHeader?.transfer_date || "-"}
            </Typography>
          </Box>

          {/* Transfer From Name */}
          <Box sx={{ minWidth: 200 }}>
            <Typography variant="body2" color="text.secondary">
              Transfer From Name
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {dataHeader?.transfer_from_name || "-"}
            </Typography>
          </Box>

          {/* Transfer To Name */}
          <Box sx={{ minWidth: 200 }}>
            <Typography variant="body2" color="text.secondary">
              Transfer To Name
            </Typography>
            <Typography variant="body2" fontWeight="bold">
              {dataHeader?.transfer_to_name || "-"}
            </Typography>
          </Box>
        </Box>

        {/* Table Responsive */}
  <TableContainer
    component={Paper}
    sx={{ borderRadius: 2, overflowX: "auto", boxShadow: 1 }}
  >
    <Table size="small">
      <TableHead>
        <TableRow sx={{ bgcolor: "#f0f0f0" }}>
          <TableCell><Typography fontWeight="bold">No</Typography></TableCell>
          <TableCell><Typography fontWeight="bold">Product Code</Typography></TableCell>
          <TableCell><Typography fontWeight="bold">Product Name</Typography></TableCell>
          <TableCell ><Typography fontWeight="bold">Qty</Typography></TableCell>
          <TableCell><Typography fontWeight="bold">Outstanding Qty</Typography></TableCell>
          <TableCell><Typography fontWeight="bold">Qty Process</Typography></TableCell>
          <TableCell ><Typography fontWeight="bold">Price</Typography></TableCell>
          <TableCell ><Typography fontWeight="bold">Total</Typography></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.length > 0 ? (
          data.map((item, index) => (
            <TableRow key={index}>
              <TableCell>{index + 1}</TableCell>
              <TableCell>{item.product_code ? item.product_code : "-"}</TableCell>
              <TableCell>{item.product_name ? item.product_name : "-"}</TableCell>
              <TableCell >{item.qty ? item.qty : "-"}</TableCell>
              <TableCell >{item.outstanding_qty ? item.outstanding_qty : "-"}</TableCell>
              <TableCell>{item.qty_proses ? item.qty_proses : "-"}</TableCell>
              <TableCell >
                {item.price?.toLocaleString("id-ID", {
                  style: "currency",
                  currency: "IDR",
                }) ? item.price?.toLocaleString("id-ID", {
                  style: "currency",
                  currency: "IDR",
                }) : "-"}
              </TableCell>
              <TableCell>
                {item.subtotal?.toLocaleString("id-ID", {
                  style: "currency",
                  currency: "IDR",
                }) ? item.subtotal?.toLocaleString("id-ID", {
                  style: "currency",
                  currency: "IDR",
                }) : "-"}
              </TableCell>
            </TableRow>
          ))
        ) : (
          <TableRow>
            <TableCell colSpan={6} align="center">
              Tidak ada data
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  </TableContainer>
      </Box>
    </Dialog>
  );
};

export default ReceiveDetailDialog;
